module.exports = __webpack_public_path__ + "static/img/ent-detail-54.3ba92f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-54.jpg
// module id = zyKH
// module chunks = 52